export default {
  loginUser: (
    app_id: string,
    userId: string,
    email?: string,
    name?: string,
    created_at?: string,
    custom_data?: Record<string, any>
  ) => {
    (window as any).intercomSettings = {
      app_id,
      user_id: userId,
      email,
      name,
      created_at,
      custom_data,
    };
    if (!document.getElementById("intercom-script")) {
      const script = document.createElement("script");
      script.id = "intercom-script";
      script.src = `https://widget.intercom.io/widget/${app_id}`;
      script.async = true;

      script.onload = () => {
        (window as any).Intercom?.("boot", (window as any).intercomSettings);
      };

      document.body.appendChild(script);
    } else {
      (window as any).Intercom?.("boot", (window as any).intercomSettings);
    }
  },

  logout: () => {
    (window as any).Intercom?.("shutdown");
  },
};
